export const DefaultLevelsArray = [0, 5, 10, 20, 30, 40, 50, 60, 80, 100];
